import { useMemo } from 'react';
import paper from '~/assets/icons/hand_2.svg';
import scissors from '~/assets/icons/peace.svg';
import rock from '~/assets/icons/stone.svg';
import { rage, useObservable } from '~/rage';
import { RockPaperScissorsChoice, RockPaperScissorsGameStatus } from '~/shared';
import { useLayoutSelector } from '../../redux';
import {
	StyledBottomText,
	StyledContainer,
	StyledIcon,
	StyledResultText,
} from './ResultOverlay.styled';

const ResultOverlay = () => {
	const status = useObservable(rage.rockPaperScissors.getStatus());
	const playerChoice = useLayoutSelector(
		(state) => state.rockPaperScissors.playerChoice,
	);
	const opponentChoice = useObservable(
		rage.rockPaperScissors.getOpponentChoice(),
	);

	const maskImage = useMemo(() => {
		if (playerChoice === RockPaperScissorsChoice.PAPER) {
			return `url(${paper})`;
		} else if (playerChoice === RockPaperScissorsChoice.SCISSORS) {
			return `url(${scissors})`;
		} else {
			return `url(${rock})`;
		}
	}, [playerChoice]);

	if (
		status === RockPaperScissorsGameStatus.WAITING ||
		status === RockPaperScissorsGameStatus.PLAYING
	) {
		return null;
	}

	return (
		<StyledContainer>
			<StyledIcon
				$type={status}
				style={{ maskImage: maskImage, WebkitMaskImage: maskImage }}
			/>
			<StyledResultText $type={status}>
				{status === RockPaperScissorsGameStatus.WON
					? 'Вы выиграли!'
					: status === RockPaperScissorsGameStatus.LOST
					? 'Вы проиграли!'
					: 'У вас ничья!'}
			</StyledResultText>
			<StyledBottomText>
				Ваш соперник выбрал{' '}
				{opponentChoice === RockPaperScissorsChoice.PAPER
					? 'бумагу'
					: opponentChoice === RockPaperScissorsChoice.SCISSORS
					? 'ножницы'
					: 'камень'}
			</StyledBottomText>
		</StyledContainer>
	);
};

export { ResultOverlay };
